<template>
  <div
    class="panelItem singleItemcustom flex w-full justify-between border-b border-infra-highlight-200 py-1 hover:border-none"
  >
    <div
      class="body-3 relative flex items-center"
      :style="{ width: item.class === 'powerplant' ? '50%' : '60%' }"
    >
      {{ item.label }}
      <ToolTipOnHover
        v-if="item.help_text"
        class="ml-0.5"
        :tooltip-text="item.help_text"
        :icon-size="18"
      />
    </div>
    <div
      :style="{ width: item.class === 'powerplant' ? '48%' : '38%' }"
      class="flex items-center"
      :class="
        item.type !== 'boolean'
          ? 'justify-start overflow-hidden hover:z-10 hover:overflow-visible'
          : 'justify-end'
      "
    >
      <DropdownField
        v-if="item.type === 'choice'"
        :item="item"
        :is-loading="getPropertyDataIsLoading"
        v-bind="$attrs"
      />
      <CheckboxField
        v-else-if="item.type === 'boolean'"
        :item="item"
        :is-loading="getPropertyDataIsLoading"
        v-bind="$attrs"
      />
      <InputField
        v-else
        :item="item"
        :class="item.key"
        :is-loading="getPropertyDataIsLoading"
        v-bind="$attrs"
      />
    </div>
  </div>
</template>

<script>
import InputField from './InputField.vue';
import CheckboxField from './CheckboxField.vue';
import DropdownField from './DropdownField.vue';
import { mapGetters } from 'vuex';
import ToolTipOnHover from '@/components/storybook/src/stories/toolTipOnHover/ToolTipOnHover.vue';

export default {
  components: {
    ToolTipOnHover,
    InputField,
    CheckboxField,
    DropdownField,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('map', ['getPropertyDataIsLoading']),
  },
};
</script>

<style lang="scss">
.panelItem {
  .left-outside-custom {
    box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.1);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .right-outside-custom {
    box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.1);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
</style>
